// import "../assets/css/style.css";

import { Link } from "react-router-dom";
const BannerTwo = () => {
  return (
    <div
      className="ht__bradcaump__area__home__banner__two"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull.jfif"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container__home__banner__two">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 ms-auto right">
              <h1>Step Into the Future of Crypto Trading</h1>
              <p>
                Access global markets with precision, speed, and total
                transparency. Trade top digital assets anytime and elevate your
                strategy with a platform engineered for effortless performance.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

export default BannerTwo;
